import {Component, h} from "preact";
import {RuntimeDetails} from "./Runtime/RuntimeDetails";


/**
 * @typedef {{
 *      runtimes: Membership.Runtime[],
 *      selected: ?number,
 *      onSelect: function(?Membership.Runtime),
 *      onProceed: function(),
 * }} RuntimeStepContent.Props
 *
 * @typedef {{
 * }} RuntimeStepContent.State
 */
export class RuntimeStepContent extends Component
{
	/**
	 * @param {RuntimeStepContent.Props} props
	 * @param {RuntimeStepContent.State} state
	 * @returns {JSX.Element}
	 */
	render (props, state)
	{
		return (
			<div class="_membership-runtimes">
				<div class="_membership-headline">Wähle Deine Mitgliedschaft</div>
				{props.runtimes.map((runtime, index) =>
					(<RuntimeDetails
						runtime={runtime}
						selected={props.selected}
						isFirstEntry={index === 0}
						isLastEntry={index === props.runtimes.length - 1}
						onSelect={() => props.onSelect(runtime)}
					/>)
				)}
				<div class="_membership-proceed">
					<button type="button" class="_membership-proceed-button" onClick={props.onProceed}>Weiter</button>
				</div>
			</div>
		);
	}
}
